/** Snap service segment length to 15-minute steps. Default min is 15; last finishing blocks may use 0. */
export function clampStep15(mins, minMinutes = 15) {
  const min = minMinutes === 0 ? 0 : 15;
  const n = Number(mins);
  if (!Number.isFinite(n)) return min;
  const stepped = Math.round(n / 15) * 15;
  return Math.min(480, Math.max(min, stepped));
}

/** Snap processing gap to 15-minute steps (0–480). */
export function clampGapMinutes(mins) {
  const n = Number(mins);
  if (!Number.isFinite(n)) return 0;
  const stepped = Math.round(n / 15) * 15;
  return Math.min(480, Math.max(0, stepped));
}

/** Human-readable length, e.g. 0m, 45m, 1h, 1.5h, 1h 45m, 2h. */
export function formatDurationHuman(totalMinutes) {
  const n = Number(totalMinutes);
  if (Number.isFinite(n) && n === 0) return "0m";
  const m = clampStep15(totalMinutes);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${h}h`;
  if (rem === 30) return `${h}.5h`;
  return `${h}h ${rem}m`;
}

/** Human-readable gap length, including 0m. */
export function formatGapHuman(totalMinutes) {
  const m = clampGapMinutes(totalMinutes);
  if (m === 0) return "0m";
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (rem === 0) return `${h}h`;
  if (rem === 30) return `${h}.5h`;
  return `${h}h ${rem}m`;
}
